import BuildingSvg from '../assets/building.svg';
import MembersSvg from '../assets/members.svg';
import PenAndPaperSvg from '../assets/pen-and-paper.svg';
import AlertSvg from '../assets/alert.svg';
import IdCardSvg from '../assets/id-card.svg';
import CalendarSvg from '../assets/calendar.svg';
import AvatarStarSvg from '../assets/avatar-star.svg';
import CareSettingSvg from '../assets/care-setting.svg';
import TaskListSvg from '../assets/task-list.svg';
import SpeedTimeSvg from '../assets/speed-time.svg';
import AllHandSvg from '../assets/all-hand.svg';

export const disciplineBasedRolesIcons = [
  {
    statementIds: [152, 154, 155, 156, 158],
    icon: BuildingSvg,
  },
  {
    statementIds: [113, 114, 115, 135, 143, 144, 145, 148, 162, 165, 179, 180],
    icon: MembersSvg,
  },
  {
    statementIds: [116, 118, 137, 146, 167, 168, 169, 170, 171, 172, 173, 174],
    icon: PenAndPaperSvg,
  },
  {
    statementIds: [190, 138],
    icon: AlertSvg,
  },
  {
    statementIds: [119, 122, 123, 124, 125, 127, 177, 178],
    icon: IdCardSvg,
  },
  {
    statementIds: [110],
    icon: CalendarSvg,
  },
  {
    statementIds: [181, 191, 192],
    icon: AvatarStarSvg,
  },
  {
    statementIds: [117, 120, 121, 128, 129, 136, 141, 183, 184],
    icon: CareSettingSvg,
  },
  {
    statementIds: [111, 149, 150, 151, 163, 164, 166, 186, 188, 189],
    icon: TaskListSvg,
  },
  {
    statementIds: [109, 131, 132, 133, 134],
    icon: SpeedTimeSvg,
  },
  {
    statementIds: [130, 161, 182, 185],
    icon: AllHandSvg,
  },
];

export const skillRatingCriteria = [
  {
    level: 1,
    title: 'Beginner',
    description: [
      'Has basic knowledge of the technology but lacks practical experience.',
      'Requires guidance and support to complete tasks.',
    ],
  },
  {
    level: 2,
    title: 'Intermediate',
    description: [
      'Has a solid understanding of the technology and can perform common tasks independently.',
      'May need assistance with more complex or specialized tasks.',
    ],
  },
  {
    level: 3,
    title: 'Advanced',
    description: [
      'Has a deep understanding of the technology and can apply it effectively in various contexts.',
      'Can troubleshoot problems and provide guidance to others.',
    ],
  },
  {
    level: 4,
    title: 'Expert',
    description: [
      'Has extensive experience with the technology and is highly proficient in its use.',
      'Can independently develop and implement solutions using the technology.',
    ],
  },
  {
    level: 5,
    title: 'Mastery',
    description: [
      'Has exceptional knowledge and skills in the technology.',
      'Can serve as a thought leader and mentor to others.',
    ],
  },
];
